import * as React from 'react'
import styled, { keyframes } from 'styled-components'
import { browserCheck } from '@ta-interaktiv/browsercheck'

const isMobile = browserCheck.isMobile
const isTablet = browserCheck.isTablet

interface Props {
  isFinished: boolean
  spread: number
  hideDetails: boolean
  estimate: number
}

const noTransformKeyframes = keyframes`
  100% {
    transform: rotate(0deg);
  }
`

const wiggleTransformKeyframes = (spread: number) => keyframes`
  2% {
    transform: rotate(${spread * 0}deg);
  }
  5% {
    transform: rotate(${spread * Math.random()}deg);
  }
  7% {
    transform: rotate(${spread * 0}deg);
  }
  9% {
    transform: rotate(${spread * 0}deg);
  }
  11% {
    transform: rotate(${spread * Math.random()}deg);
  }
  17% {
    transform: rotate(${spread * Math.random()}deg);
  }
  19% {
    transform: rotate(-${spread * Math.random()}deg);
  }
  22% {
    transform: rotate(-${spread * Math.random()}deg);
  }
  24% {
    transform: rotate(${spread * 0}deg);
  }
  26% {
    transform: rotate(${spread * 0}deg);
  }
  29% {
    transform: rotate(${spread * 0.66}deg);
  }
  32% {
    transform: rotate(${spread * Math.random()}deg);
  }
  35% {
    transform: rotate(${spread * 0}deg);
  }
  39% {
    transform: rotate(${spread * 0}deg);
  }
  45% {
    transform: rotate(-${spread * Math.random()}deg);
  }
  55% {
    transform: rotate(${spread * Math.random()}deg);
  }
  62% {
    transform: rotate(-${spread * Math.random()}deg);
  }
  68% {
    transform: rotate(-${spread * Math.random()}deg);
  }
  70% {
    transform: rotate(${spread * 0}deg);
  }
  72% {
    transform: rotate(${spread * 0}deg);
  }
  75% {
    transform: rotate(-${spread * 0.66}deg);
  }
  78% {
    transform: rotate(-${spread * Math.random()}deg);
  }
  83% {
    transform: rotate(${spread * 0}deg);
  }
  86% {
    transform: rotate(${spread * 0}deg);
  }
  90% {
    transform: rotate(-${spread * Math.random()}deg);
  }
  100% {
    transform: rotate(${spread * 0}deg);
  }
`

function Needle(props: Props) {
  const { isFinished, spread, hideDetails, estimate } = props

  const keyframes = React.useMemo(() => {
    if (isFinished) {
      return noTransformKeyframes
    } else {
      return wiggleTransformKeyframes(spread)
    }
  }, [isFinished, spread])

  const Wiggle = styled.div`
    animation: ${keyframes} 3.5s linear infinite;
    width: 100%;
    position: absolute;
    transform: rotate(0deg);
    transform-origin: 50% 93.5%;
    display: table;
  `

  return (
    <Wiggle>
      <div
        style={{
          pointerEvents: 'none',
          transformOrigin: hideDetails
            ? isMobile
              ? '50.5% 83.5%'
              : isTablet
                ? '55.5% 80.5%'
                : '50% 93.5%'
            : '50% 93.5%', // approx. centerpoint of the needles base, should be the same for styled div 'Wiggle'
          transform: `rotate(${(100 - estimate / 100) * 180 + 90}deg)`,
        }}
      >
        <svg
          version="1.1"
          className="needle"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="100%"
          viewBox="0 0 436 249"
          enableBackground="new 0 0 436 249"
          xmlSpace="preserve"
          style={{
            width: '100%',
            fill: 'var(--text-color)',
            ...({ colorScheme: 'light dark' } as any),
          }}
        >
          <g id="Layer_1" />
          <g id="Layer_2">
            <g id="needle_00000155108739464683201240000005335254353896812947_">
              <path
                className="st0"
                d="M211.5759,219.7792c-7.6403,3.7388-10.7289,13.0047-6.99,20.6449s13.0047,10.7289,20.6449,6.99
        c7.6403-3.7388,10.7289-13.0047,6.99-20.6449C228.3194,219.129,219.2161,216.0403,211.5759,219.7792z M221.4919,240.099
        c-3.5763,1.7881-7.9654,0.3251-9.7535-3.4137c-1.7881-3.5763-0.3251-7.9654,3.4137-9.7535
        c3.7388-1.7881,7.9654-0.3251,9.7535,3.4137C226.6938,233.9218,225.2308,238.3109,221.4919,240.099z"
              />
              <path
                className="st0"
                d="M225.2705,219.7792L218.2805,0l-6.5023,219.7792C216.1673,217.6659,221.2066,217.8285,225.2705,219.7792
        L225.2705,219.7792z"
              />
            </g>
          </g>
        </svg>
      </div>
    </Wiggle>
  )
}

export default Needle
